import React, { useEffect, useState, useRef, useCallback } from 'react'
import {db} from '../../../'
import { set, ref, get, remove, onValue } from 'firebase/database';
import { useNavigate, useLocation } from 'react-router-dom';
import TabMenu from '../../components/TabMenu';
import ShareModal from '../ShareModal';
import NetabareModal from '../NetabareModal';
import ConfirmModal from '../../components/ConfirmModal';
import BasicInfoTab from './BasicInfoTab';
import TeamsTab from './TeamsTab';
import MissionsTab from './MissionsTab';
import ItemsTab from './ItemsTab';
import MembersTab from './MembersTab';
import NotificationsTab from './NotificationsTab';
import { dateToDatetimeLocal, shiftDatetimeLocal } from './utils';

const EditGame = ({userData}) => {
    //ゲームIDの取得
    const location = useLocation();
    const [gameID, setGameID] = useState(location.state ? location.state.gameID : null);
    const [saveStatus, setSaveStatus] = useState(0);
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const isInitialLoadRef = useRef(true);
    const lastUpdateTimeRef = useRef(null); // reflectDataを安定した参照に保つため、lastUpdateTimeを常に反映するref
    const suppressDirtyCheckRef = useRef(false); // 保存直後、自分自身の書き込みがonValueで返ってきて未保存扱いに戻ってしまうのを防ぐフラグ

    const navigate = useNavigate();
    const [gameId, setGameId] = useState("");
    const [selectedTab, setSelectedTab] = React.useState(0)
    const tabMenu = ['基本情報', 'チーム', 'ミッション', 'アイテム', '参加者', '通知']

    const [teams, setTeams] = useState([]);
    const [members, setMembers] = useState([]);

    const [missions, setMissions] = useState([]);
    const [specialItems, setSpecialItems] = useState([]);

    const [activated, setActivated] = useState(false);
    const [error, setError] = useState(null);

    // ゲームの共有
    const [shareModalIsOpen, setShareModalIsOpen] = useState(false);
    const [urlToEdit, setUrlToEdit] = useState("");

    // 「全ての時間をずらす」の確認・結果モーダル
    const [changeAllTimeConfirmOpen, setChangeAllTimeConfirmOpen] = useState(false);
    const [changeAllTimeResult, setChangeAllTimeResult] = useState(null); // {invalidMissionNames: []} | null

    // ネタバレ防止用のモーダル
    const [netabareModalIsOpen, setNetabareModalIsOpen] = useState(false);
    const [packageGame, setPackageGame] = useState(false);

    //フォームの参照
    //基本情報
    const [name, setName] = useState("");
    const [detail, setDetail] = useState("");
    const [publicCheck, setPublic] = useState(false);
    const [auto, setAuto] = useState(true);
    const [startTime, setStartTime] = useState("");
    const [prepareLimitTime, setPrepareLimitTime] = useState("");
    const [endTime, setEndTime] = useState("");
    const [lat, setLat] = useState(35.6895);
    const [lng, setLng] = useState(139.7514);
    const [zoom, setZoom] = useState(12);
    const [gameMode, setGameMode] = useState(0);
    const [activeChangeAlltimeBtn, setActiveChangeAlltimeBtn] = useState(false);
    const [oldStartTime, setOldStartTime] = useState("");

    //ミッション（発令時刻はゲーム読込時に親から直接セットされるため、ここに残す）
    const [missionStartTime, setMissionStartTime] = useState("");

    //参加者
    const [showUpdateNotification, setShowUpdateNotification] = useState(false); // 更新通知表示
    const [autoSave, setAutoSave] = useState(false); // 自動保存のオンオフ（切替UIは現在コメントアウト中のため常にfalse）
    // eslint-disable-next-line no-unused-vars -- 自動保存UI（コメントアウト中）を有効化する際に使用する表示用フラグ
    const [isAutoSaving, setIsAutoSaving] = useState(false); // 自動保存中フラグ
    const autoSaveTimeoutRef = useRef(null); // 自動保存のタイマー

    //AI用参考情報
    const [gameLocation, setGameLocation] = useState("");
    const [gameConcepts, setGameConcepts] = useState([false, false, false, false, false, false, false, false, false, false]);

    //通知
    const [discordWebhook, setDiscordWebhook] = useState("");
    const [notifyOption, setNotifyOption] = useState([true, true]);

    // データの反映
    const reflectData = useCallback((data) => {
        // 更新時刻をチェックして通知表示
        if (data.info && data.info.updateDate) {
            if (lastUpdateTimeRef.current && lastUpdateTimeRef.current !== data.info.updateDate) {
                setShowUpdateNotification(true);
                // 3秒後に通知を非表示
                setTimeout(() => setShowUpdateNotification(false), 3000);
            }
            lastUpdateTimeRef.current = data.info.updateDate;
        }

        //アクティベート済みかどうか
        const activatedRef = ref(db, "activatedGames/" + gameID);
        get(activatedRef).then((snapshot) => {
            if(snapshot.exists()) {
                if(snapshot.val().activated) {
                    setActivated(true);
                }
            }
        });

        //データの反映
        setTeams(data.teams ? data.teams : []);
        setMissions(data.missions ? data.missions : []);
        setSpecialItems(data.specialItems ? data.specialItems : []);
        setMembers(() => {
            let newMembers = [];
            if(!data.members) return newMembers;

            Object.keys(data.members).forEach((key) => {
                newMembers.push({
                    name: data.members[key].name,
                    email: data.members[key].email,
                    uid: data.members[key].uid,
                    team: (data.members[key].team || data.members[key].team === 0) ? data.members[key].team : null,
                    memberCode: data.members[key].memberCode || null,
                    registered: data.members[key].registered || false
                });
            })
            return newMembers
        });

        //基本情報
        setName(data.info.name);
        setDetail(data.info.detail);
        setPublic(data.info.public);
        setAuto(data.info.auto);
        setStartTime(data.info.startTime);
        setPrepareLimitTime(data.info.prepareLimitTime);
        setEndTime(data.info.endTime);
        setLat(data.info.mapCenter.lat);
        setLng(data.info.mapCenter.lng);
        setZoom(data.info.mapCenter.zoom);
        setGameLocation(data.info.location);
        setGameConcepts(data.info.concepts ? data.info.concepts : [false, false, false, false, false, false, false, false, false, false]);
        setGameMode(data.info.gameMode);
        setUrlToEdit(data.info.urlToEdit ? data.info.urlToEdit : "");
        setMissionStartTime(data.info.startTime ? dateToDatetimeLocal(new Date(data.info.startTime)) : "");
        setOldStartTime(data.info.startTime ? dateToDatetimeLocal(new Date(data.info.startTime)) : "");

        // 通知
        setDiscordWebhook(data.notify ? data.notify.discordWebhook : "");
        setNotifyOption(data.notify ? data.notify.option : [true, true]);

        // ゲームパックかどうか
        if(data.info.package) {
            setPackageGame(true);
        } else {
            setPackageGame(false);
        }

        setSaveStatus(2);
        // 少し遅延させて初期読み込み完了とする
        setTimeout(() => {
            isInitialLoadRef.current = false;
        }, 100);
    }, [gameID]);

    //読み込み時、ゲームIDを生成 or 取得
    useEffect(() => {
        if(gameID) {
            //既存のゲームデータ
            setGameId(gameID);

            // ゲーム全体のリアルタイム監視を設定
            const gameRef = ref(db, 'games/' + gameID);
            const unsubscribeGame = onValue(gameRef, (snapshot) => {
                //ゲームが存在しない場合、トップページにリダイレクト
                if(!snapshot.exists()) {
                    alert("ゲームが見つかりませんでした");
                    navigate('/');
                } else {
                    // 初回読み込み完了フラグを設定
                    if (isInitialLoadRef.current) {
                        isInitialLoadRef.current = false;
                    }
                    reflectData(snapshot.val());
                }
            });

            // クリーンアップ関数でリスナーを削除
            return () => {
                unsubscribeGame();
            };
        } else {
            //新規ゲームデータ
            setGameId(Math.random().toString(36).slice(-6));
            // 新規ゲームの場合は少し遅延させて初期読み込み完了とする
            setTimeout(() => {
                isInitialLoadRef.current = false;
            }, 100);
        }
    }, [gameID, navigate, reflectData]);

    // オーナーシップの簡易チェック（フロントエンドの防御的チェック。実際の制御はサーバー側で行う）
    useEffect(() => {
        if(!gameID) return; // 新規作成の場合はチェック不要
        if(!userData || userData.loading) return;

        if(userData.createdGames) {
            const owns = Object.values(userData.createdGames || {}).includes(gameID);
            if(!owns) {
                navigate('/');
            }
        }
    }, [userData, gameID, navigate]);

    // ゲームデータが変更された際、未保存の状態にする
    // saveStatusをここで依存に含めると、保存直後（setSaveStatus(2)）に自分自身を再度「未保存」（1）へ
    // 戻してしまうため、フォーム項目が変化した時のみ発火する意図的な設計とする。
    useEffect(() => {
        // 初期読み込み中は何もしない
        if(isInitialLoadRef.current) return;

        // 保存直後、自分自身の書き込みがonValueで反映されて teams/members/missions/specialItems 等の
        // 参照が更新されたことによる誤発火を1回だけスキップする
        if(suppressDirtyCheckRef.current) {
            suppressDirtyCheckRef.current = false;
            return;
        }

        // 新規作成時（saveStatus = 0）または保存済み（saveStatus = 2）の場合のみ未保存に変更
        if(saveStatus === 0 || saveStatus === 2) {
            setSaveStatus(1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [name, detail, publicCheck, auto, startTime, prepareLimitTime, endTime, lat, lng, zoom, gameLocation, gameConcepts, gameMode, discordWebhook, notifyOption, teams, members, missions, specialItems]);

    //時刻の自動入力
    useEffect(() => {
        if(startTime) {
            if(!prepareLimitTime) {
                const date = new Date(startTime);
                date.setHours(date.getHours() + 9);
                date.setMinutes(date.getMinutes() + 15);
                setPrepareLimitTime(date.toISOString().slice(0, 16));
            }

            if(!endTime) {
                const date = new Date(startTime);
                date.setHours(date.getHours() + 6 + 9);
                setEndTime(date.toISOString().slice(0, 16));
            }
        }
    }, [startTime, prepareLimitTime, endTime]);

    // すべてのミッションの開始時刻が設定されていて、かつゲーム時間中であるかどうか
    const checkMissionTime = () => {
        let result = [];
        missions.forEach((mission, index) => {
            if(!mission.time.start || !mission.time.end) {
                result.push(index);
            } else {
                if(new Date(mission.time.start) < new Date(startTime) || new Date(mission.time.end) > new Date(endTime)) {
                    result.push(index);
                }
            }
        });

        return result;
    }

    // ミッションまたはアイテムのタブを表示した際、ゲームパックのデータであれば、ネタばれ防止のモーダルを表示
    useEffect(() => {
        if(selectedTab === 2 || selectedTab === 3) {
            if(packageGame) {
                setNetabareModalIsOpen(true);
            }
        }
    }, [selectedTab, packageGame]);

    // ゲーム編集者を招待するためのURLを生成して保存
    const createNewEditURL = () => {
        const result = window.confirm('ゲーム編集者を招待するためのURLを生成しますか？');
        if(!result) return;

        // Realtime Databaseの「ShareToEdit」に、ランダムなキーを持たせて、その中にゲームIDを保存
        const randomKey = Math.random().toString(36).slice(-10);
        set(ref(db, 'shareToEdit/' + randomKey), {
            gameID: gameId,
            name: name,
            date: new Date().toISOString(),
            username: userData.username,
        })
        .then(() => {
            // 生成したURLを表示
            const url = window.location.origin + "/acceptEditorAuth?key=" + randomKey;
            setUrlToEdit(url);
        })
        .catch((error) => {
            console.error('招待URLの生成に失敗しました:', error);
            alert("招待URLの生成に失敗しました。");
        });
    }

    // すべてのミッションなどの時刻を、新しいゲーム開始時刻に合わせて一気に変更（確認モーダルを開く）
    const changeAllTime = () => {
        setChangeAllTimeConfirmOpen(true);
    }

    // 確認モーダルで「実行する」が押されたときの実処理
    const executeChangeAllTime = () => {
        setChangeAllTimeConfirmOpen(false);

        // 新旧のスタート時刻の時間差の計算
        const oldStartDate = new Date(oldStartTime);
        const newStartDate = new Date(startTime);
        console.log("旧スタート時刻: " + oldStartDate);
        console.log("新スタート時刻: " + newStartDate);
        const timeDiff = newStartDate.getTime() - oldStartDate.getTime();
        console.log("時間差: " + timeDiff + "ミリ秒");

        if(isNaN(timeDiff)) {
            setError("開始時刻が正しく設定されていないため、時刻をずらせませんでした");
            return;
        }

        // 逃走準備終了時刻、終了時刻を計算してセット（不正な値の場合は変更せず据え置く）
        const newPrepareLimitTime = shiftDatetimeLocal(prepareLimitTime, timeDiff);
        if(newPrepareLimitTime !== null) setPrepareLimitTime(newPrepareLimitTime);

        const newEndTime = shiftDatetimeLocal(endTime, timeDiff);
        if(newEndTime !== null) setEndTime(newEndTime);

        // ミッションの開始時刻を変更（形式が不正なミッションはスキップし、あとでまとめて結果モーダルで知らせる）
        const invalidMissionNames = [];
        const newMissions = missions.map((mission) => {
            let newMission = {...mission};
            if(newMission.time.start) {
                const shifted = shiftDatetimeLocal(newMission.time.start, timeDiff);
                if(shifted === null) {
                    invalidMissionNames.push(mission.name);
                } else {
                    newMission.time.start = shifted;
                }
            }

            return newMission;
        });
        setMissions(newMissions);

        setActiveChangeAlltimeBtn(false);
        setOldStartTime(startTime);

        setChangeAllTimeResult({ invalidMissionNames });
    }

    // 開催地名から座標を自動入力
    const getLatLngFromLocation = () => {
        if (!gameLocation) return;
        setError(null);

        // Google Maps Geocoding APIを使って、開催地名から座標を取得
        fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(gameLocation)}&key=${process.env.REACT_APP_API_KEY}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.status === "OK") {
                    const location = data.results[0].geometry.location;
                    setLat(location.lat);
                    setLng(location.lng);
                } else {
                    setError("座標の取得に失敗しました");
                    console.error("Geocoding API error:", data.status, data.error_message);
                }
            })
            .catch((error) => {
                setError("座標の取得に失敗しました");
            });
    }

    // ゲームデータのバリデーションを行う
    const validateGameData = (errorPrefix = "") => {
        //時刻が設定されていない場合、エラー
        if(!startTime || !prepareLimitTime || !endTime) {
            return errorPrefix + "時刻が設定されていません";
        }

        //ゲーム名が設定されていない場合、エラー
        if(!name) {
            return errorPrefix + "ゲーム名が設定されていません";
        }

        // ゲーム名は20文字以内
        if(name.length > 20) {
            return errorPrefix + "ゲーム名は20文字以内で設定してください";
        }

        //地図の中心座標が設定されていない場合、エラー
        if(!lat || !lng || !zoom) {
            return errorPrefix + "地図の中心座標が設定されていません";
        }

        //時刻が順番になっていない場合、エラー
        if(auto) {
            if(new Date(startTime) > new Date(prepareLimitTime) || new Date(prepareLimitTime) > new Date(endTime)) {
                return errorPrefix + "時刻が正しく設定されていません";
            }
        } else {
            if(new Date(startTime) > new Date(endTime)) {
                return errorPrefix + "時刻が正しく設定されていません";
            }
        }

        // ミッションの時刻が正しく設定されているか
        const missionTimeError = checkMissionTime();
        if(missionTimeError.length > 0) {
            let error = errorPrefix;
            missionTimeError.forEach((index) => {
                error = error + " 「" + missions[index].name + "」は、開始時刻がゲーム時間中になっていません。";
            });
            return error;
        }

        // バリデーション成功
        return null;
    };

    //保存・送信
    const saveGame = () => {
        if(saving) return;

        setError(null);

        const validationError = validateGameData();
        if (validationError) {
            setError(validationError);
            return;
        }

        const gameData = makeOutputData();
        setSaving(true);
        suppressDirtyCheckRef.current = true;

        //データベースに保存
        set(ref(db, 'games/' + gameId), gameData)
        .then(() => {
            //既存のゲームでない場合、ユーザーデータに追加
            if(!gameID) {
                return set(ref(db, 'users/' + userData.uid + '/history/create/' + gameId), {
                    name: gameData.info.name,
                    date: new Date().toISOString()
                }).then(() => {
                    return set(ref(db, 'users/' + userData.uid + '/createdGames/' + gameId), gameId)
                    .then(() => {
                        alert("ゲームを保存しました");
                        setSaveStatus(2);
                        setGameID(gameId);
                        setSaving(false);
                    })
                })
            } else {
                alert("ゲームを保存しました");
                setSaveStatus(2);
                setSaving(false);
            }
        })
        .catch((error) => {
            console.error('ゲームの保存に失敗しました:', error);
            alert("ゲームの保存に失敗しました。");
            setSaveStatus(1);
            setSaving(false);
        });
    }

    // 自動保存を実行する
    const executeAutoSave = () => {
        if (!autoSave) return;

        setIsAutoSaving(true);

        // 既存のエラー状態をクリア
        setError(null);

        // バリデーションを実行
        const validationError = validateGameData("自動保存エラー: ");
        if (validationError) {
            setError(validationError);
            setAutoSave(false);
            setIsAutoSaving(false);
            return;
        }

        // バリデーション通過、保存実行
        try {
            const gameData = makeOutputData();
            suppressDirtyCheckRef.current = true;

            //データベースに保存
            set(ref(db, 'games/' + gameId), gameData)
            .then(() => {
                console.log('自動保存完了');
                setIsAutoSaving(false);
                setSaveStatus(2);
            })
            .catch((error) => {
                console.error('自動保存エラー:', error);
                setError("自動保存エラー: " + error.message);
                setAutoSave(false);
                setIsAutoSaving(false);
            });
        } catch (error) {
            console.error('自動保存エラー:', error);
            setError("自動保存エラー: " + error.message);
            setAutoSave(false);
            setIsAutoSaving(false);
        }
    };

    // 自動保存をトリガーする（デバウンス処理）
    const triggerAutoSave = () => {
        if (!autoSave) return;

        // 既存のタイマーをクリア
        if (autoSaveTimeoutRef.current) {
            clearTimeout(autoSaveTimeoutRef.current);
        }

        // 2秒後に自動保存を実行
        autoSaveTimeoutRef.current = setTimeout(() => {
            executeAutoSave();
        }, 2000);
    };

    // JSON出力
    const downloadJson = () => {
        const data = makeOutputData();

        const blob = new Blob([JSON.stringify(data)], {type: 'application/json'});
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = gameId + '.json';
        a.click();
        window.URL.revokeObjectURL(url);
    }

    // JSON入力
    const importJson = async () => {
        try {
            const [handle] = await window.showOpenFilePicker({
              types: [
                {
                  accept: {
                    'text/json': ['.json']
                  }
                }
              ]
            })
            const file = await handle.getFile();

            const reader = new FileReader();
            reader.onload = (e) => {
                const data = JSON.parse(e.target.result);
                reflectData(data);
            }
            reader.readAsText(file);
        } catch (err) {
            console.error(err.name, err.message)
        }
    }

    // データ作成
    const makeOutputData = () => {
        const data = {
            info: {
                name: name,
                detail: detail,
                public: publicCheck,
                auto: auto,
                startTime: startTime,
                prepareLimitTime: prepareLimitTime,
                endTime: endTime,
                mapCenter: {
                    lat: Number(lat),
                    lng: Number(lng),
                    zoom: Number(zoom)
                },
                updateDate: new Date().toISOString(),
                location: gameLocation,
                concepts: gameConcepts,
                gameMode: gameMode, // 0: 代わり鬼, 1: 増やし鬼
                urlToEdit: urlToEdit ? urlToEdit : null,
                package: packageGame ? true : false
            },
            members: members,
            teams: teams,
            missions: missions,
            specialItems: specialItems ? specialItems : null,
            notify: {
                discordWebhook: discordWebhook ? discordWebhook : null,
                option: notifyOption ? notifyOption : [false, false]
            }
        }

        return data;
    }

    // ゲームの削除
    const deleteGame = () => {
        // アクティベート済みの場合、削除不可
        if(activated) {
            alert("アクティベート済みのため、削除できません");
            return;
        }

        if(deleting) return;

        const result = window.confirm('本当に削除しますか？');
        if(!result) return;

        setDeleting(true);

        //ゲームデータの削除
        remove(ref(db, 'games/' + gameId))
        .then(() => {
            //ユーザーデータの削除
            return remove(ref(db, 'users/' + userData.uid + '/createdGames/' + gameId))
            .then(() => {
                alert("ゲームを削除しました");
                navigate('/')
            })
        })
        .catch((error) => {
            console.error('ゲームの削除に失敗しました:', error);
            alert("ゲームの削除に失敗しました。");
            setDeleting(false);
        });
    }

    return (
        <div className='max-w-6xl mx-auto my-6'>
            <h2 className='text-center text-2xl mb-6'>ゲームを編集</h2>

            {/* リアルタイム更新通知 */}
            {showUpdateNotification && (
                <div className='fixed top-4 right-4 bg-blue-500 text-white px-4 py-2 rounded-lg shadow-lg z-50 animate-pulse'>
                    <i className='bi bi-arrow-clockwise me-2'></i>
                    ゲームデータが更新されました
                </div>
            )}

            {/* ゲームIDの表示 */}
            <div className='text-center mb-6'>
                <div className='mb-2'>
                    <label className='text-gray-600 me-2'>ゲームID</label>
                    <span className='text-2xl play-bold border-b border-gray-400 px-2'>{gameId}</span>
                </div>
                <div className=''>
                    <button onClick={() => downloadJson()} type="button" className='bg-white border text-gray-700 rounded-lg p-2 px-4 hover:bg-gray-50 me-2'><i className='bi bi-download me-2'></i>出力</button>
                    <button onClick={() => importJson()} type="button" className='bg-white border text-gray-700 rounded-lg p-2 px-4 hover:bg-gray-50 me-2'><i className='bi bi-upload me-2'></i>インポート</button>
                    <button onClick={() => setShareModalIsOpen(true)} type="button" className='bg-white border text-gray-700 rounded-lg p-2 px-4 hover:bg-gray-50 me-2'><i className='bi bi-share me-2'></i>共有</button>
                    <button onClick={() => saveGame()} disabled={saving} type="button" className='bg-purple-500 text-white rounded-lg p-2 px-4 hover:bg-purple-700 me-2 disabled:opacity-50'><i className='bi bi-floppy me-2'></i>保存</button>
                </div>

                {/* 自動保存設定 */}
                {/* <div className='mt-2 flex items-center'>
                    <label className='flex items-center cursor-pointer text-sm'>
                        <input
                            type="checkbox"
                            checked={autoSave}
                            onChange={(e) => setAutoSave(e.target.checked)}
                            className='mr-2'
                        />
                        <i className='bi bi-floppy me-1'></i>
                        自動保存
                    </label>
                    {isAutoSaving && (
                        <span className='ml-3 text-sm text-gray-500'>
                            <i className='bi bi-arrow-repeat me-1 spinning'></i>
                            保存中...
                        </span>
                    )}
                    {!autoSave && error && error.includes("自動保存エラー") && (
                        <span className='ml-3 text-sm text-red-500'>
                            <i className='bi bi-exclamation-triangle me-1'></i>
                            バリデーションエラーで無効化されました
                        </span>
                    )}
                </div> */}

                {/* 保存済み？ */}
                {saveStatus === 2 && (
                    <div className='text-gray-500 mt-1 text-sm'><i className='bi bi-check-lg text-lime-600 me-2'></i>保存済み</div>
                )}
                {saveStatus === 1 && (
                    <div className='text-gray-500 mt-1 text-sm'><i className='bi bi-x-lg text-red-600 me-2'></i>未保存の変更があります</div>
                )}

                {/* エラー */}
                {error && (
                    <div className='text-center'>
                        <div className='bg-red-400/10 text-red-600 mt-2 py-2 px-4 rounded-lg inline-block'><i className='bi bi-exclamation-triangle me-2'></i>{error}</div>
                    </div>
                )}
            </div>

            <TabMenu options={tabMenu} active={selectedTab} setActive={(index) => setSelectedTab(index)} />

            {/* タブは常時マウントしたまま、CSSのhiddenで表示切替する（タブ切替でフォームの編集内容やfocus状態が消えないようにするため） */}
            <div className={selectedTab === 0 ? '' : 'hidden'}>
                <BasicInfoTab
                    name={name} setName={setName}
                    detail={detail} setDetail={setDetail}
                    publicCheck={publicCheck} setPublic={setPublic}
                    auto={auto} setAuto={setAuto}
                    startTime={startTime} setStartTime={setStartTime}
                    prepareLimitTime={prepareLimitTime} setPrepareLimitTime={setPrepareLimitTime}
                    endTime={endTime} setEndTime={setEndTime}
                    lat={lat} setLat={setLat}
                    lng={lng} setLng={setLng}
                    zoom={zoom} setZoom={setZoom}
                    gameLocation={gameLocation} setGameLocation={setGameLocation}
                    gameMode={gameMode} setGameMode={setGameMode}
                    activated={activated}
                    deleting={deleting}
                    gameID={gameID}
                    activeChangeAlltimeBtn={activeChangeAlltimeBtn} setActiveChangeAlltimeBtn={setActiveChangeAlltimeBtn}
                    oldStartTime={oldStartTime}
                    triggerAutoSave={triggerAutoSave}
                    getLatLngFromLocation={getLatLngFromLocation}
                    changeAllTime={changeAllTime}
                    deleteGame={deleteGame}
                />
            </div>

            <div className={selectedTab === 1 ? '' : 'hidden'}>
                <TeamsTab
                    teams={teams} setTeams={setTeams}
                    members={members} setMembers={setMembers}
                    name={name}
                    triggerAutoSave={triggerAutoSave}
                />
            </div>

            <div className={selectedTab === 2 ? '' : 'hidden'}>
                <MissionsTab
                    missions={missions} setMissions={setMissions}
                    missionStartTime={missionStartTime} setMissionStartTime={setMissionStartTime}
                    startTime={startTime}
                    gameId={gameId}
                    gameLocation={gameLocation}
                    gameConcepts={gameConcepts}
                    name={name}
                    triggerAutoSave={triggerAutoSave}
                    setError={setError}
                />
            </div>

            <div className={selectedTab === 3 ? '' : 'hidden'}>
                <ItemsTab
                    specialItems={specialItems} setSpecialItems={setSpecialItems}
                    triggerAutoSave={triggerAutoSave}
                />
            </div>

            <div className={selectedTab === 4 ? '' : 'hidden'}>
                <MembersTab
                    members={members} setMembers={setMembers}
                    teams={teams}
                    gameId={gameId}
                    name={name}
                    triggerAutoSave={triggerAutoSave}
                />
            </div>

            <div className={selectedTab === 5 ? '' : 'hidden'}>
                <NotificationsTab
                    discordWebhook={discordWebhook} setDiscordWebhook={setDiscordWebhook}
                    notifyOption={notifyOption} setNotifyOption={setNotifyOption}
                    name={name}
                />
            </div>

            <ShareModal
                isOpen={shareModalIsOpen}
                setIsOpen={(newState) => setShareModalIsOpen(newState)}
                urlToJoin={window.location.origin + "/join?gameId=" + gameId}
                urlToEdit={urlToEdit}
                createNewEditURL={() => createNewEditURL()}
                saveStatus={saveStatus}
            />

            <NetabareModal
                isOpen={netabareModalIsOpen}
                onClose={() => setNetabareModalIsOpen(false)}
                onLeave={() => {
                    setNetabareModalIsOpen(false);
                    setSelectedTab(0);
                }}
            />

            <ConfirmModal
                isOpen={changeAllTimeConfirmOpen}
                mode="confirm"
                title="時刻を一括変更"
                message={"すべてのミッションやアイテムの時刻を、新しいゲーム開始時刻に合わせて変更しますか？"}
                confirmLabel="変更する"
                cancelLabel="キャンセル"
                onConfirm={() => executeChangeAllTime()}
                onCancel={() => setChangeAllTimeConfirmOpen(false)}
            />

            <ConfirmModal
                isOpen={changeAllTimeResult !== null}
                mode="notice"
                title={changeAllTimeResult && changeAllTimeResult.invalidMissionNames.length > 0 ? "一部のミッションは変更できませんでした" : "時刻を変更しました"}
                message={
                    changeAllTimeResult && changeAllTimeResult.invalidMissionNames.length > 0
                        ? "以下のミッションは開始時刻の形式が正しくないため、時刻をずらせませんでした。お手数ですが個別に修正してください。\n" + changeAllTimeResult.invalidMissionNames.join("\n")
                        : "すべてのミッション・アイテムの時刻を変更しました。"
                }
                onClose={() => setChangeAllTimeResult(null)}
            />
        </div>
    );
};

export default EditGame;
